import { Folder } from "../../redux/interfaces/folder.types.ts";
import { UI_DASHBOARD_EXPRESS } from "../../constants/common.ts";
import { Tooltip } from "antd";
import { FileWordFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import React from "react";

interface Props {
  folder: Folder;
}

export const StartContract: React.FC<Props> = ({ folder }) => {
  const folderNumber = folder.folder_number;
  const lease_contract_id = folder.metadata?.lease_contract?.id;

  const contractLink = lease_contract_id
    ? `${UI_DASHBOARD_EXPRESS}/contracts/${lease_contract_id}/edit`
    : `${UI_DASHBOARD_EXPRESS}/contracts/${folderNumber}/create`;

  return (
    <Link to={contractLink} target="_blank" rel="noopener noreferrer">
      <Tooltip title="Generar contrato" className="cursor-pointer">
        <FileWordFilled
          style={{ fontSize: "18px" }}
          className="text-gray-600 hover:text-blue-400"
        />
      </Tooltip>
    </Link>
  );
};
